module.exports = __webpack_public_path__ + "OpenSans-SemiboldItalic-ec55f263e2b86bc0f28fff46b873d6df.woff";